module.exports = __webpack_public_path__ + "img/youtube-green.eb212475.svg";